module.exports = "https://static.wagwalking.com/_next/static/images/daily-wag-mobile-placeholder-16e9edfe3cc4f60162329e2c7775b953.jpeg";